import { Badge } from '@/components/ui/badge'
import { useTranslation } from 'react-i18next'

type BadgeVariant =
    | 'default'
    | 'secondary'
    | 'outline'
    | 'destructive'
    | 'success'

/** Maps asset status to Badge variant */
const getStatusVariant = (status: string): BadgeVariant => {
    switch (status?.toUpperCase()) {
        case 'PUBLISHED':
            return 'success'
        case 'DRAFT':
            return 'secondary'
        case 'PENDING':
        case 'PROCESSING':
            return 'default'
        case 'REJECTED':
            return 'destructive'
        case 'ARCHIVED':
            return 'outline'
        default:
            return 'secondary'
    }
}

interface AssetStatusBadgeProps {
    status: string
    className?: string
}

const AssetStatusBadge = ({ status, className }: AssetStatusBadgeProps) => {
    const { t } = useTranslation('asset')

    return (
        <Badge variant={getStatusVariant(status)} className={className}>
            {t(`asset_statuses.${status}`)}
        </Badge>
    )
}

export default AssetStatusBadge
